<template>
  <div id="contact-edit">
    <vs-alert
      v-if="latestVisit && !latestVisit.checkoutTime"
      class="mb-4"
      :title="contactDataModel.firstName + ' ' + contactDataModel.lastName + ' Latest Visit'"
      color="rgb(231, 154, 23)"
      active="true">
      <div class="vx-row">
        <div class="vx-col w-full lg:w-1/2">
          <p>
            <strong>Sign In Time:</strong>
            <span>{{latestVisit.checkinTime | longDate}}</span>
          </p>
          <p class="mt-1">
            <strong>Sign Out Time:</strong>
            <span v-if="latestVisit.checkoutTime">{{latestVisit.checkoutTime | longDate}}</span>
            <span v-if="!latestVisit.checkoutTime">Not Signed Out</span>
          </p>
        </div>
        <div class="vx-col w-full lg:w-1/2">
          <vs-button class="ml-auto mt-1" @click.prevent="signoutVisit(latestVisit.id)" icon-pack="feather" icon="icon-check" icon-before>Sign Out Visit</vs-button>
        </div>
      </div>
    </vs-alert>

    <vx-card
      v-if="contactDataModel"
      :title="'Edit ' + contactDataModel.firstName + ' ' + contactDataModel.lastName"
      class="mb-6"
    >
      <FormContact ref="form" :data="contactDataModel" />
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-button
            class="ml-auto"
            icon-pack="feather"
            icon="icon-check"
            icon-before
            @click.prevent="saveChanges">Save Changes</vs-button>
        </div>
      </div>
    </vx-card>

    <tc-table
      :dataList="contactVisits"
      :tbody="tbody"
      :settings="{
        externalFilters: {
          show: false
        }
      }">
      <template slot="thead">
        <vs-th sort-key="name">Status</vs-th>
        <vs-th sort-key="category">Location</vs-th>
        <!-- <vs-th sort-key="category">Hosted By</vs-th> -->
        <vs-th sort-key="popularity">Sign In</vs-th>
        <vs-th sort-key="popularity">Sign Out</vs-th>
        <vs-th sort-key="popularity">Actions</vs-th>
      </template>
    </tc-table>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ContactsVisitsTableBody from '@/components/tc-toble-body/ContactsVisits';
import FormContact from '@/components/tc-popup-content/FormContact';
import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment';

export default {
  components: {
    FormContact
  },
  data () {
    return {
      isMounted: false,
      contactDataModel: null,
      tbody: {
        component: ContactsVisitsTableBody,
        methods: {
          signout: id => {
            this.signoutVisit(id);
          }
        }
      },
      visitsLength: 0,
    };
  },
  computed: {
    ...mapState('visitManagement', {
      contact: state => state.contact
    }),
    contactVisits () {
      return this.contact.visits || []
    },
    latestVisit () {
      try {
        return this.contactDataModel.visits[this.visitsLength];
      } catch (error) {
        return null;
      }
    },
  },
  watch: {
    contact: function (newContact, oldContact) {
      const oldContactVisits = (oldContact || []).visits || [];
      if (this.contactDataModel && oldContactVisits.length > 0) {
        const newContactLength = newContact.visits.length - 1;
        const oldContactLength = oldContact.visits.length - 1;
        const newContactVisitCheckoutTime = newContact.visits[newContactLength].checkoutTime;
        const oldContactVisitCheckoutTime = oldContact.visits[oldContactLength].checkoutTime;
        if (newContactVisitCheckoutTime !== oldContactVisitCheckoutTime) {
          this.contactDataModel.visits[this.visitsLength].checkoutTime = newContactVisitCheckoutTime;
        }
      }
    },
  },
  methods: {
    async saveChanges () {
      const form = this.$refs.form;
      if (form) {
        const result = await form.validateThenSubmit();
        if (result) {
          this.contactDataModel = cloneDeep(result)
          form.form = cloneDeep(result)
        }
      }
    },
    async signoutVisit(visitId) {
      const hasRelatedVisitsCheckoutTime = await this.checkRelatedVisitsCheckoutTime(visitId);
      const mainVisit = await this.fetchVisit(visitId);

      if (hasRelatedVisitsCheckoutTime.length > 0) {
        hasRelatedVisitsCheckoutTime.map(item => item.toCheckout = false);
        return this.$root.$tcPopup.show({
          data: {
            relatedVisits: hasRelatedVisitsCheckoutTime,
            visit: mainVisit,
          },
          classes: 'vs-dialog--md',
          title: 'Checkout',
          component: 'CheckoutVisit',
          buttonsHidden: true
        })
      }

      await this.$store.dispatch('visitManagement/signoutVisit', {
          visitId: visitId,
          route: this.$route
      }).then(result => {
        this.contactDataModel.visits[this.visitsLength].checkoutTime = result.data.checkoutTime;
      });
    },
    async checkRelatedVisitsCheckoutTime (visitId) {
      const visit = await this.fetchVisit(visitId);
      const relatedVisits = (visit || {}).relatedVisits || [];
      const relatedVisitsLen = relatedVisits.length;
      if (relatedVisitsLen > 0) {
        const relatedVisitsCheckout = relatedVisits.filter(rv => rv.checkoutTime === null);
        return relatedVisitsCheckout;
      }

      return [];
    },
    async fetchVisit(visitId) {
      return await this.$store.dispatch('visitManagement/fetchVisit', { id: visitId });
    },
  },
  created () {
    const me = this;
    this.$store.dispatch('visitManagement/fetchContact', this.$route.params.id)
      .then(function (data) {
        const dataCopy = cloneDeep(data);
        if(dataCopy.inductionExpiryDate) {
          const momentObj = moment.utc(dataCopy.inductionExpiryDate,'YYYY-MM-DD[T]HH:mm:sss[Z]');
          dataCopy.inductionExpiryDate = momentObj.local().format("DD-MM-YYYY HH:mm");
        }
        me.contactDataModel = dataCopy;
        me.visitsLength = data.visits.length - 1;
      })
  },
  mounted () {
    this.isMounted = true;
  }
};
</script>
